export default "__VITE_ASSET__3bXVaxG7__"